import { Language } from '../constants';
export const TAGS_LIMIT_DEFAULT = -1;
export const AUTOCOMPLETE_TRANSLATIONS_KEYS = {
  accessibleLabelTagRemove: 'component.Autocomplete.accessibleLabelTagRemove',
  accessibleLabelButtonClearSearch: 'component.Autocomplete.accessibleLabelButtonClearSearch',
  noOptionsLabel: 'component.Autocomplete.noOptionsLabel',
  isLoadingLabel: 'component.Autocomplete.isLoadingLabel'
};
export const AUTOCOMPLETE_TRANSLATIONS = {
  [Language.CS]: {
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.isLoadingLabel]: 'načítání...',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.noOptionsLabel]: 'žádné výsledky',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.accessibleLabelButtonClearSearch]: 'Vyčistit',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.accessibleLabelTagRemove]: _ref => {
      let {
        selectedOption
      } = _ref;
      return `Odznačit ${selectedOption}`;
    }
  },
  [Language.EN]: {
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.isLoadingLabel]: 'loading...',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.noOptionsLabel]: 'no options',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.accessibleLabelButtonClearSearch]: 'Clear',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.accessibleLabelTagRemove]: _ref2 => {
      let {
        selectedOption
      } = _ref2;
      return `Unselect ${selectedOption}`;
    }
  },
  [Language.PL]: {
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.isLoadingLabel]: 'wczytywanie...',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.noOptionsLabel]: 'brak wyników',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.accessibleLabelButtonClearSearch]: 'Wyczyść',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.accessibleLabelTagRemove]: _ref3 => {
      let {
        selectedOption
      } = _ref3;
      return `Odznacz ${selectedOption}`;
    }
  },
  [Language.SK]: {
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.isLoadingLabel]: 'načítava...',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.noOptionsLabel]: 'žiadne výsledky',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.accessibleLabelButtonClearSearch]: 'Vyčistiť',
    [AUTOCOMPLETE_TRANSLATIONS_KEYS.accessibleLabelTagRemove]: _ref4 => {
      let {
        selectedOption
      } = _ref4;
      return `Odznačiť ${selectedOption}`;
    }
  }
};
export const AutocompleteSearchCriteriaChangeReason = {
  INPUT: 'input',
  SELECTION: 'selection',
  CLEAR: 'clear',
  SUBMIT: 'submit'
};
export const TAG_LIMIT_CALCULATIONS = {
  inputDecorations: 112,
  averageLetterWidth: 9,
  chipDecorations: 28,
  moreThan10: 50,
  lessThan10: 40
};
export const ACCENT_CHARACTERS_REG_EXP = /[\u0300-\u036F]/g;
export const DIACRITIC_CHARACTERS_EXCEPTIONS = [{
  regexp: /\u0142/gi,
  replaceValue: 'l'
}];